(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["meter-inquire-cta"] && !Shopify.designMode) return;
  try {
    // A variant change only morphs `<variant-picker>` (variant-picker.js keeps
  // `morphElementSelector` undefined on the product page), so this block's
  // markup still carries the variant that was rendered with the page. Read the
  // option values out of the picker at click time instead.
  function selectedOptionValues(link) {
    const scope = link.closest('.shopify-section') || document;
    const picker = scope.querySelector('variant-picker') || document.querySelector('variant-picker');
    if (!picker) return '';

    // querySelectorAll keeps DOM order, so option values join in the same order
    // Shopify uses for `variant.title`. Covers both button/swatch radios and the
    // dropdown variant style.
    return Array.from(picker.querySelectorAll('input[type="radio"]:checked, select'))
      .map((field) => field.value)
      .filter(Boolean)
      .join(' / ');
  }

  function buildPrefillMessage(link) {
    const { prefillMessage, prefillBase, prefillVariantLabel } = link.dataset;
    if (!prefillBase || !prefillVariantLabel) return prefillMessage;

    const values = selectedOptionValues(link);
    return values ? prefillBase + prefillVariantLabel + values : prefillMessage;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-meter-inquire-link]');
    if (!link) return;
    try {
      // `ts` lets contact-tabs.js expire a payload that was never consumed —
      // the contact link target is merchant-editable and may lack the section.
      sessionStorage.setItem(
        'contact-prefill',
        JSON.stringify({ message: buildPrefillMessage(link), ts: Date.now() })
      );
    } catch (_) {
      // sessionStorage unavailable (private mode, quota) — contact page just opens blank.
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-inquire-cta"] && !Shopify.designMode) return;
  try {
    // Zustandswechsel bei Variantenwahl. 'variant:update' ist der Wert von
  // ThemeEvents.variantUpdate (assets/events.js) — hier als Literal, weil der
  // Javascript-Bundle der Blocks keine Imports kennt. Das Event bubbelt bis
  // zum Dokument.
  document.addEventListener('variant:update', (event) => {
    const detail = /** @type {any} */ (event).detail;
    const variantId = detail && detail.resource ? detail.resource.id : null;

    const origin = event.target;
    const scope = origin instanceof Element ? origin.closest('.shopify-section') || document : document;

    scope.querySelectorAll('[data-variant-inquire]').forEach((cta) => {
      const list = cta.getAttribute('data-inquire-variants') || ',';
      // Kein Treffer bei fehlender Variante: dann gibt es nichts zu verkaufen UND
      // nichts anzufragen — den Zustand entscheidet weiterhin buy-buttons.
      const active = variantId != null && list.includes(`,${variantId},`);

      if (active) cta.setAttribute('data-active', '');
      else cta.removeAttribute('data-active');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
